import script from "./BuildingDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuildingDetails.vue?vue&type=script&lang=ts&setup=true"

import "./BuildingDetails.vue?vue&type=style&index=0&id=7c2ac344&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c2ac344"]])

export default __exports__